import gql from 'graphql-tag';
export default gql`
  mutation DeleteContactById($input: DeleteContactByIdInput!) {
    deleteContactById(input: $input) {
      deletedContactId
    }
  }
`;
